module.exports = __webpack_public_path__ + "img/US_BuildTime_ua.10e99d32.webp";